import { z } from "zod";
import { apiListSchema } from "./list";

//? DTO
export const CreateTourAccommodationDtoSchema = z.object({
  Day: z.number().nullish(),
  TourId: z.number(),
  Priority: z.number().nullish(),
  HotelRoomId: z.number().nullish(),
  Notes: z.string().nullish(),
});
export type CreateTourAccommodationDto = z.infer<
  typeof CreateTourAccommodationDtoSchema
>;

export const TourAccommodationDtoSchema =
  CreateTourAccommodationDtoSchema.extend({ Id: z.number() });

export type TourAccommodationDto = z.infer<typeof TourAccommodationDtoSchema>;

export const TourAccommodationDtoListSchema = apiListSchema(
  TourAccommodationDtoSchema
);

//? Models

export const CreateTourAccommodationSchema = z.object({
  day: z.number(),
  tourId: z.number(),
  priority: z.number(),
  hotelRoomId: z.number().nullish(),
  notes: z.string().nullish(),
});

export const TourAccommodationSchema = CreateTourAccommodationSchema.extend({
  id: z.string().min(1),
});

export type CreateTourAccommodation = z.infer<
  typeof CreateTourAccommodationSchema
>;

export type TourAccommodation = z.infer<typeof TourAccommodationSchema>;

//? Mappers

export function tourAccommodationFromDto(
  dto: TourAccommodationDto
): TourAccommodation {
  return {
    id: dto.Id.toString(),
    day: dto.Day ?? -1,
    hotelRoomId: dto.HotelRoomId,
    notes: dto.Notes,
    tourId: dto.TourId,
    priority: dto.Priority ?? 0,
  };
}

export function tourAccommodationToDto(
  dto: TourAccommodation
): TourAccommodationDto {
  return {
    Id: Number.parseInt(dto.id),
    ...createTourAccommodationToDto(dto),
  };
}

export function createTourAccommodationToDto(
  dto: CreateTourAccommodation
): CreateTourAccommodationDto {
  return {
    Day: dto.day,
    HotelRoomId: dto.hotelRoomId,
    Notes: dto.notes,
    Priority: dto.priority,
    TourId: dto.tourId,
  };
}
